import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const About = () => {
  const certifications = [
    {
      title: '医疗器械注册证',
      number: '国械注准20231234567',
      image: 'https://readdy.ai/api/search-image?query=medical%20device%20registration%20certificate%20official%20document%20with%20seal%20and%20stamps%2C%20professional%20layout%2C%20clean%20white%20background%2C%20high%20quality%20scan&width=400&height=500&seq=cert1&orientation=portrait'
    },
    {
      title: 'ISO 13485认证',
      number: 'ISO 13485:2016',
      image: 'https://readdy.ai/api/search-image?query=ISO%2013485%20quality%20management%20system%20certification%20document%2C%20official%20certificate%20with%20logo%20and%20seal%2C%20professional%20layout%2C%20clean%20background&width=400&height=500&seq=cert2&orientation=portrait'
    },
    {
      title: '发明专利证书',
      number: 'ZL 2023 1 0123456.7',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20invention%20patent%20certificate%20official%20document%20with%20national%20emblem%2C%20red%20seal%2C%20professional%20layout%2C%20clean%20background&width=400&height=500&seq=cert3&orientation=portrait'
    }
  ];

  const news = [
    {
      id: 1,
      title: 'Mirókids亮相2024中华口腔医学会年会',
      date: '2024-03-15',
      category: '行业动态',
      image: 'https://readdy.ai/api/search-image?query=modern%20dental%20conference%20exhibition%20booth%20with%20professional%20displays%20and%20attendees%2C%20bright%20lighting%2C%20clean%20professional%20environment%2C%20business%20event%20photography&width=600&height=400&seq=news1&orientation=landscape',
      summary: '在本次年会上，Mirókids展示了最新的AI智能排牙系统，获得了与会专家的高度认可。'
    },
    {
      id: 2,
      title: '完成B轮融资，加速数字化正畸布局',
      date: '2024-02-20',
      category: '公司新闻',
      image: 'https://readdy.ai/api/search-image?query=business%20team%20celebrating%20successful%20funding%20round%20in%20modern%20office%2C%20professional%20handshake%2C%20bright%20corporate%20environment%2C%20business%20photography&width=600&height=400&seq=news2&orientation=landscape',
      summary: '本轮融资将主要用于技术研发、市场拓展和人才引进，进一步巩固行业领先地位。'
    },
    {
      id: 3,
      title: '儿童正畸公益行走进100所小学',
      date: '2024-01-10',
      category: '社会责任',
      image: 'https://readdy.ai/api/search-image?query=dental%20health%20education%20event%20at%20elementary%20school%20with%20children%20and%20dentist%2C%20bright%20classroom%20environment%2C%20educational%20activity%2C%20warm%20atmosphere&width=600&height=400&seq=news3&orientation=landscape',
      summary: '免费为10000名儿童提供口腔健康检查，普及正畸知识，守护孩子的笑容。'
    }
  ];

  const timeline = [
    { year: '2024', event: '服务患者突破50000人，覆盖全国200+城市' },
    { year: '2023', event: '推出第三代AI智能排牙系统，精准度提升至99%' },
    { year: '2022', event: '获得医疗器械注册证，正式进入市场' },
    { year: '2021', event: '完成A轮融资，建立研发中心' },
    { year: '2020', event: 'Mirókids品牌创立，专注儿童隐形矫治' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <h1 className="text-6xl font-bold mb-6">
            关于Mirókids
          </h1>
          <p className="text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            用科技守护每一个孩子的笑容，让隐形矫治更安全、更舒适、更高效
          </p>
        </div>
      </section>

      {/* Brand Story */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                品牌故事
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  Mirókids由一群来自口腔医学、材料科学和人工智能领域的专家共同创立。我们的初心很简单：<strong className="text-blue-600">让每一个孩子都能拥有自信的笑容</strong>。
                </p>
                <p>
                  传统的金属牙套不仅影响美观，还会给孩子带来心理负担。我们相信，科技可以改变这一切。通过自主研发的高分子材料和AI智能排牙系统，我们为6-12岁儿童提供了一种全新的矫治方案——<strong className="text-blue-600">硅胶矫治器、舒适、精准</strong>。
                </p>
                <p>
                  四年来，我们服务了超过50000名儿童，与全国500多家诊所建立了合作关系。每一个成功案例的背后，都是我们对品质的坚持和对创新的追求。
                </p>
                <p className="text-blue-600 font-bold text-xl">
                  "重塑微笑，预见未来" —— 这不仅是我们的使命，更是我们对每一个家庭的承诺。
                </p>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=diverse%20team%20of%20medical%20professionals%20and%20scientists%20working%20together%20in%20modern%20research%20laboratory%2C%20bright%20professional%20environment%2C%20collaborative%20atmosphere%2C%20high-tech%20equipment%2C%20warm%20lighting&width=800&height=600&seq=team&orientation=landscape"
                alt="团队照片"
                className="rounded-3xl shadow-2xl object-cover object-top w-full h-[600px]"
              />
              <div className="absolute -bottom-8 -left-8 bg-blue-600 text-white p-8 rounded-2xl shadow-xl">
                <div className="text-5xl font-bold mb-2">50000+</div>
                <div className="text-xl">服务儿童</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 px-6 bg-blue-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              发展历程
            </h2>
            <p className="text-xl text-gray-600">
              从创立到领先，每一步都踏实前行
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-blue-600 -translate-x-1/2"></div>
            <div className="space-y-12">
              {timeline.map((item, index) => (
                <div
                  key={index}
                  className={`flex items-center gap-8 ${
                    index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                  }`}
                >
                  <div className={`flex-1 ${index % 2 === 0 ? 'text-right' : 'text-left'}`}>
                    <div className="bg-white rounded-2xl shadow-lg p-8 inline-block">
                      <div className="text-3xl font-bold text-blue-600 mb-2">{item.year}</div>
                      <p className="text-lg text-gray-700">{item.event}</p>
                    </div>
                  </div>
                  <div className="w-6 h-6 bg-blue-600 rounded-full border-4 border-white shadow-lg z-10"></div>
                  <div className="flex-1"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              资质认证
            </h2>
            <p className="text-xl text-gray-600">
              权威认证，品质保障
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {certifications.map((cert, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="h-[400px] bg-gray-100 overflow-hidden">
                  <img
                    src={cert.image}
                    alt={cert.title}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{cert.title}</h3>
                  <p className="text-gray-600">{cert.number}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              新闻动态
            </h2>
            <p className="text-xl text-gray-600">
              了解我们的最新进展
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {news.map(item => (
              <div key={item.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer">
                <div className="h-[300px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
                      {item.category}
                    </span>
                    <span className="text-gray-500 text-sm">{item.date}</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 line-clamp-2">
                    {item.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              核心价值观
            </h2>
            <p className="text-xl text-gray-600">
              指引我们前行的信念
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-5xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">以患者为中心</h3>
              <p className="text-gray-600">
                始终将儿童的健康和体验放在首位
              </p>
            </div>

            <div className="text-center">
              <div className="w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-5xl text-orange-500"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">持续创新</h3>
              <p className="text-gray-600">
                不断突破技术边界，引领行业发展
              </p>
            </div>

            <div className="text-center">
              <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-5xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">品质至上</h3>
              <p className="text-gray-600">
                严格把控每一个环节，确保安全可靠
              </p>
            </div>

            <div className="text-center">
              <div className="w-24 h-24 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-5xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">合作共赢</h3>
              <p className="text-gray-600">
                与合作伙伴携手，共创美好未来
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 px-6 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">
            加入我们，共创未来
          </h2>
          <p className="text-xl mb-8 text-white/90">
            无论您是家长、医生还是合作伙伴，我们都期待与您携手
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <button className="bg-white text-blue-600 px-10 py-4 rounded-full text-lg font-bold hover:bg-blue-50 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap">
              寻找医生
            </button>
            <button className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-full text-lg font-bold hover:bg-white/10 transition-all duration-300 whitespace-nowrap">
              医生合作
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
